import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ClearTcsmSessionStorage } from '../../../global/helpers/session-storage-helper';
import { DemographicAppKeys } from '../../../global/models/demographics-model';
import { TcsmStates } from '../../../root/tcsm-model';
import { cleanSearchStores } from '../../../search/components/store-manager';
import { unloadDependentState } from '../../account-info/features/dependents/dependents-slice';
import { unloadPersonState } from '../../account-info/features/personal-info/personal-info-slice';
import { unloadRelationshipState } from '../../account-info/features/relationships/relationships-slice';
import { unloadCompensationState } from '../features/compensation/compensation-history/compensation-history-slice';
import { unSetEmploymentState } from '../features/employment/employment-slice';
import { unloadOfficersState } from '../features/institution-officers/institution-officers-slices';
import { InstitutionItem } from '../features/institutions/institution-model';
import { setEmployeeListUnloaded, unloadInstitutionState } from '../features/institutions/institution-slice';
import { clearMidYearState } from '../features/mid-year/mid-year-slices';
import { cleanBooks } from '../shared-slices/pagination-slice';

export function usePersonManagementReset(ignoreEmploymentState?: boolean, skipGroup?: boolean) {
	const dispatch = useDispatch();

	const list = useSelector<TcsmStates, InstitutionItem[]>(a => a.institutionState?.institutionList);

	useEffect(() => {
		if (list && list.length > 1) {
			dispatch(unloadInstitutionState());
			dispatch(unloadOfficersState());
			dispatch(setEmployeeListUnloaded());
		}

		if (!ignoreEmploymentState) {
			dispatch(unSetEmploymentState());
		}

		dispatch(unloadCompensationState());
		dispatch(unloadPersonState(DemographicAppKeys.arc));
		dispatch(unloadRelationshipState(DemographicAppKeys.arc));
		dispatch(unloadDependentState(DemographicAppKeys.arc));
		dispatch(clearMidYearState());
		ClearTcsmSessionStorage(skipGroup);
	}, []);
}

export function useSearchListsReset() {
	const dispatch = useDispatch();

	useEffect(() => {		
		cleanSearchStores();
		dispatch(cleanBooks());
	}, []);
}